import { NgModule } from '@angular/core';
import { IridescenceBackgroundComponent } from './iridescence-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        IridescenceBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        IridescenceBackgroundComponent
    ]
})
export class NcIridescenceBackgroundModule { }